module.exports = __webpack_public_path__ + "img/wlogo.5a30abdd.png";